/**
 * @flow
 * @relayHash 9161b0ff7844baae8ef8b8ce93c38fce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PricingContractDetails_viewer$ref = any;
export type PricingContractDetailsQueryVariables = {|
  contractId?: ?string
|};
export type PricingContractDetailsQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PricingContractDetails_viewer$ref
  |}
|};
export type PricingContractDetailsQuery = {|
  variables: PricingContractDetailsQueryVariables,
  response: PricingContractDetailsQueryResponse,
|};
*/


/*
query PricingContractDetailsQuery(
  $contractId: ID
) {
  viewer {
    ...PricingContractDetails_viewer_1sMWdv
    id
  }
}

fragment PricingContractDetails_viewer_1sMWdv on Query {
  contracts(id: $contractId) {
    edges {
      node {
        id
        currency
        symbol
        latestContractFinancialData {
          closingPriceLocal
          id
        }
        exchange {
          name
          symbol
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contractId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PricingContractDetailsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PricingContractDetails_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "contractId",
                "variableName": "contractId"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PricingContractDetailsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contracts",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "contractId"
              }
            ],
            "concreteType": "ContractNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "latestContractFinancialData",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LatestContractFinancialDataNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "closingPriceLocal",
                            "args": null,
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "exchange",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ExchangeNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PricingContractDetailsQuery",
    "id": null,
    "text": "query PricingContractDetailsQuery(\n  $contractId: ID\n) {\n  viewer {\n    ...PricingContractDetails_viewer_1sMWdv\n    id\n  }\n}\n\nfragment PricingContractDetails_viewer_1sMWdv on Query {\n  contracts(id: $contractId) {\n    edges {\n      node {\n        id\n        currency\n        symbol\n        latestContractFinancialData {\n          closingPriceLocal\n          id\n        }\n        exchange {\n          name\n          symbol\n          id\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad4a45f69ea481745df4f2a9d59e527e';
module.exports = node;
